<template>
  <div class="list-sort" v-if="sortArr.length">
    <span class="list-sort-title"> {{ $t('Show first') }}: </span>
    <sort-products-item class="list-sort-link"
                        :class="{ 'is-active': item.status }"
                        v-for="item in sortArr"
                        :key="item.id"
                        :item="item"
    />
  </div>
</template>

<script>
import SortBy from '@vue-storefront/core/compatibility/components/SortBy'
import SortProductsItem from 'theme/components/core/blocks/Shop/Product/Sort/SortProductsItem'

export default {
  components: {
    SortProductsItem
  },
  mixins: [SortBy],
  props: {
    hasLabel: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      sortby: this.$store.state.config.products.defaultSortBy.attribute,
      sortArr: [],
      labelArr: ['Cheap', 'Expensive', 'Popular']
    }
  },
  created () {
    this.$bus.$on('change-sort-data', payload => {
      this.sortby = payload.value
      this.sortArr.map(el => { el.status = false })
      this.sortArr[payload.id].status = true
      this.changeOrder()
    })
  },
  mounted () {
    this.createSortArr()
  },
  methods: {
    createSortArr () {
      let defaultSortBy = `${this.$store.state.config.products.defaultSortBy.attribute}:${this.$store.state.config.products.defaultSortBy.order}`
      Object.keys(this.sortByAttribute).map((el, key) => {
        if (key > 0) {
          this.sortArr.push({
            id: key - 1,
            label: this.labelArr[key - 1],
            value: this.sortByAttribute[el],
            status: defaultSortBy === this.sortByAttribute[el]
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.list-sort {
  display: flex;
  align-items: center;

  @media only screen and (max-width: 465px) {
    margin-top: 20px;
  }

  &-title {
    margin-right: 10px;

    color: #9b9b9b;
    font-size: 14px;
    font-weight: 400;
  }

  &-link {
    color: #4a4a4a;
    font-size: 14px;
    font-weight: 400;

    transition: .2s;

    & + & {
      margin-left: 20px;
    }

    &.is-active, &:hover {
      cursor: pointer;
      color: #11bb2e;
      text-decoration: underline;
    }
  }
}
</style>
